import { FunctionComponent } from 'react';
import SocialMediaIcons from '../../../../utils/SocialMediaIcons';
import UniversityGeneralImages from "./UniversityGeneralImages";
import UniversityGeneralCosts from './UniversityGeneralCosts';
import UniversityGeneralAccommodation from './UniversityGeneralAccommodation';
import UniversityGeneralConclusion from './UniversityGeneralConclusion';
import University from '../../../../../networking/models/University';
import { getUniversityUrlForSlug } from '../../../../../utils/mediaAccount';
import { MediaAccount } from '../../../../../utils/icon';
import Contact from '../../../../../assets/images/illustratie_contact_old_student.svg';
import PageCard from '../../../../layout/PageCard';
import Map from '../../../layout/Map';
import UniversityGeneralReviews from './UniversityGeneralReviews/UniversityGeneralReviews';

interface Props {
    university: University;
    formParts?: University;
}

const UniversityGeneral: FunctionComponent<Props> = ({ university, formParts }) => {

    return (
        <div className="university-general">
            <div className="university-general__header">
                <UniversityGeneralImages images={university.images!} />

                <div className="university-general__description-container">
                    <div className="university-general__rating">
                        {/* {
                            university.responses !== 0 && <Rating rating={university.rating!} sideText={`(${university.responses} responses)`} />
                        }                     */}
                        <div className="university-general__location">
                            {university.country?.name}, {university.city}
                        </div>
                    </div>

                    <div className="university-general__description">
                        {university.description}
                    </div>

                    <SocialMediaIcons
                        className="university-general__social-media"
                        instagram={getUniversityUrlForSlug(university, MediaAccount.INSTA)}
                        twitter={getUniversityUrlForSlug(university, MediaAccount.TWITTER)}
                        facebook={getUniversityUrlForSlug(university, MediaAccount.FACEBOOK)}
                        website={getUniversityUrlForSlug(university, MediaAccount.WEB)}
                    />
                </div>
            </div>

            <UniversityGeneralReviews university={university} />

            <div className={'university-general__map'}>
                <h2 className="university-general__costs-title">Map</h2>

                <Map latitude={university.latitude ?? 51.9851034} longitude={university.longitude ?? 5.8987296}/>
            </div>

            {
                formParts && <UniversityGeneralCosts university={formParts} />
            }

            <UniversityGeneralAccommodation university={formParts} />

            <UniversityGeneralConclusion university={formParts} />

            <br></br>

            <h2>MORE INFORMATION?</h2>

            <div className="university-general__more-information">
                <PageCard image={Contact} imageAlt={"study idea"} text={"Contact student"}
                    link={`/universities/${university.id}/contact`} />
            </div>
        </div>
    )
}

export default UniversityGeneral;
